import styled  from "styled-components";
import { device } from "helper/constants";


export const ModalWrapper = styled.div``;